import React from "react";

const Java_Import = () => {
  return (
    <div>
      <h1>Java Import</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Import in Java.</p>
    </div>
  );
};

export default Java_Import;
